export const PaymentGatewayEnum = {
    CardPointe: "cardpointe",
    TSYS: "tsys",
    Dejavoo: "dejavoo",
    Bolt: "bolt",
    Converge: "converge",
    Unigate: "unigate",
    SeamlessPay: "seamlesspay",
    Pax: "pax",
}

export type PaymentGateway = (typeof PaymentGatewayEnum)[keyof typeof PaymentGatewayEnum]
